<div class="pallet-modal modal-content login-troubleshoot-modal" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">Trouble Logging In?</span>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" alt="Close" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <div class="troubleshoot-container">
      <ul class="troubleshoot-list">
        <li class="troubleshoot-item">
          <strong class="troubleshoot-item-title">Clear Browser Cache and Cookies</strong>
          <small class="troubleshoot-item-description">
            • For Chrome: Settings > Privacy and security > Clear browsing data<br />
            • For Firefox: Options > Privacy & Security > Clear Data<br />
            • For Safari: Preferences > Privacy > Manage Website Data
          </small>
        </li>
        <li class="troubleshoot-item">
          <strong class="troubleshoot-item-title">Try Different Browser or Device</strong>
          <small class="troubleshoot-item-description">
            • Use Chrome if you're on Firefox<br />
            • Use private/incognito mode for troubleshooting
          </small>
        </li>
        <li class="troubleshoot-item">
          <strong class="troubleshoot-item-title">Verify Login Credentials</strong>
          <small class="troubleshoot-item-description">
            • Double-check for any typos<br />
            • Verify you're using the right email address<br />
            • Try "Forgot Password" if unsure<br />
            • Check your CAPS LOCK is off
          </small>
        </li>
      </ul>
      <div class="support-action">
        <button class="btn-contact-support" (click)="contactSupport()">Contact Support</button>
      </div>
    </div>
  </div>
</div>
